import React from 'react';
import './ProfileMenu.css';
import { NavLink } from 'react-router-dom';

interface ProfileMenuProps {
  menu: { name: string; link: string }[];
}

const ProfileMenu: React.FC<ProfileMenuProps> = ({ menu }) => {
  return (
    <>
      {menu.map((item) => (
        <NavLink
          to={item.link}
          className={({ isActive, isPending }) =>
            (isPending ? 'pending' : isActive ? 'active' : '') +
            ' prof_menu first'
          }
        >
          {item.name}
        </NavLink>
      ))}
      {/* <NavLink
        to="/profile/activity"
        className={({ isActive, isPending }) =>
          (isPending ? 'pending' : isActive ? 'active' : '') +
          ' prof_menu first'
        }
      >
        Activity
      </NavLink>
      <NavLink
        to="/profile/skills"
        className={({ isActive, isPending }) =>
          (isPending ? 'pending' : isActive ? 'active' : '') + ' prof_menu'
        }
      >
        Skills
      </NavLink>
      <NavLink
        to="/profile/credentials"
        className={({ isActive, isPending }) =>
          (isPending ? 'pending' : isActive ? 'active' : '') + ' prof_menu'
        }
      >
        Credentials
      </NavLink>
      <NavLink
        to="/profile/pathways"
        className={({ isActive, isPending }) =>
          (isPending ? 'pending' : isActive ? 'active' : '') + ' prof_menu'
        }
      >
        Pathways
      </NavLink>
      <NavLink
        to="/profile/programs"
        className={({ isActive, isPending }) =>
          (isPending ? 'pending' : isActive ? 'active' : '') + ' prof_menu'
        }
      >
        Programs
      </NavLink>
      <NavLink
        to="/profile/courses"
        className={({ isActive, isPending }) =>
          (isPending ? 'pending' : isActive ? 'active' : '') + ' prof_menu'
        }
      >
        Courses
      </NavLink>
      <NavLink
        to="/profile/public-profile"
        className={({ isActive, isPending }) =>
          (isPending ? 'pending' : isActive ? 'active' : '') + ' prof_menu'
        }
      >
        Public Profile
      </NavLink> */}
    </>
  );
};

export { ProfileMenu };
